import React from 'react';

import AdCollection from '../../components/employerProfile/AdCollection';
import VideoCollection from '../../components/video/VideoCollection';
import PreviewProfileHeader from './PreviewProfileHeader';
import ImageCollection from '../ProfileView/images/ImageCollection';
import AmbassadorContainer from '../ProfileView/ambassadors/AmbassadorContainer';
import ProfileTopBar from '../../components/employerProfile/ProfileTopBar';
import ProfileInfo from '../../components/employerProfile/ProfileInfo';
import { Provider } from '../../components/employerProfile/FollowButtonContext';
import PropTypes from 'prop-types';

class PreviewProfileUI extends React.Component {
    static propTypes = {
        companyActiveAds: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        followCompany: PropTypes.shape({
            inprogressFollowUnFollow: PropTypes.bool,
            detailsFetched: PropTypes.bool.isRequired,
            isFollowing: PropTypes.bool.isRequired,
            onUnfollowCompanyClick: PropTypes.func.isRequired,
            onFollowCompanyClick: PropTypes.func.isRequired,
            numberOfFollowers: PropTypes.number.isRequired,
        }).isRequired,
        profile: PropTypes.shape({
            ambassadors: PropTypes.shape({
                ambassadors: PropTypes.array,
            }),
            companyName: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
            images: PropTypes.shape({
                images: PropTypes.array,
            }),
            videos: PropTypes.shape({
                videos: PropTypes.array,
            }),
        }).isRequired,
    };

    setActiveFollowButton = (id) => {
        this.setState({
            followButtonContext: {
                activeFollowButton: id,
                setActiveFollowButton: this.setActiveFollowButton,
            },
        });
    };

    state = {
        followButtonContext: {
            activeFollowButton: null,
            setActiveFollowButton: this.setActiveFollowButton,
        },
    };

    renderAdCollection() {
        return (
            <AdCollection
                ads={this.props.companyActiveAds}
                className="u-pv32"
                dispatch={this.props.dispatch}
                followCompany={this.props.followCompany}
                profile={this.props.profile}
            />
        );
    }

    render() {
        if (!this.props.profile) {
            return null;
        }

        const adCollection = this.renderAdCollection();
        const images = this.props.profile.images
            ? this.props.profile.images.images
            : [];
        const videos = this.props.profile.videos
            ? this.props.profile.videos.videos
            : [];
        const ambassadors = this.props.profile.ambassadors
            ? this.props.profile.ambassadors.ambassadors
            : [];

        return (
            <Provider value={this.state.followButtonContext}>
                <ProfileTopBar
                    followCompany={this.props.followCompany}
                    profile={this.props.profile}
                />

                <section className="u-hide-lt768">
                    <PreviewProfileHeader {...this.props.profile} />
                </section>

                <ProfileInfo profile={this.props.profile} />

                <VideoCollection disabled videos={videos} />

                <ImageCollection images={images} />

                <AmbassadorContainer
                    ambassadors={ambassadors}
                    profileId={this.props.profile.id}
                />

                {adCollection}
            </Provider>
        );
    }
}

export default PreviewProfileUI;
